import { genId } from "../../../utils";

export const exportTopBlockSchema = {
  _id: genId(),
  name: 'exportTopBlockSchema',
  content: [
    {
      name: 'root',
      type: 'Container',
      displaySettings: {className: 'schema-print-preview'},
      children: [
        {
          name: 'utilsContainer',
          type: 'Container',
          displaySettings: { as: 'Container' },
          children: [
            {
              name:'utilsRow',
              type: 'Container',
              displaySettings:{as:'Row'},
              children:[
                {name:'reportBlockUtilities', type: 'reportBlockUtilities'}
              ]
            },
          ]
        },
          {
            name: 'titleContainer',
            type: 'Container',
            displaySettings: { as: 'Container' },
            children: [
              {
                name:'repTypeRow',
                type:'Container',
                displaySettings: {as: 'Row', className:'report-type-row'},
                children: [{
                  name: 'reportType',
                  type: 'text',
                  displaySettings:{className:'report-type'},
                  placeholder: 'Report Type',
                  
                }]
              },
              {
                name:'repNameRow',
                type:'Container',
                displaySettings: {as: 'Row', className:'report-name-row'},
                children:[
                  {
                    name: 'name',
                    type: 'text',
                    displaySettings:{className:'report-name'},
                    placeholder: 'Report Title',
                    
                  },
                ]
              },
              {
                name:'propAddressRow',
                type:'Container',
                displaySettings: {as: 'Row', className:'report-property-address-row'},
                children:[
                  {
                    name: 'propertyAddress',
                    type: 'text',
                    displaySettings:{ className: 'report-property-address' },
                    placeholder: 'Property Address',
                  },
    
                ]
              },
              {
                name:'coverRow',
                type:'Container',
                displaySettings: {as: 'Row', className:'report-cover-photo-row'},
                children:[
                  {
                    name: 'coverPhoto',
                    type: 'image',
                    displaySettings:{ className: 'report-cover-photo' },
                    placeholder: 'Cover Photo',
                    options: {thumbnailSize:'lg'}
                  },
                ]
              },
              {
                name:'preparedRow',
                type:'Container',
                displaySettings:{as: 'Row', className:'report-prepared-row'},
                children: [
                  {
                    name:'dateCol',
                    type:'Container',
                    displaySettings:{as: 'Col', sm: 4, className:'report-prepared-date-col'},
                    children: [
                      {
                        name: 'date',
                        type: 'text',
                        placeholder: 'Date'
                      }
                    ]
                  },
                  {
                    name:'preparedForCol',
                    type:'Container',
                    displaySettings:{as: 'Col', sm:4, className:'report-prepared-for-col'},
                    children: [
                      {
                        name:'preparedForPhotoContainer',
                        type:'Container',
                        displaySettings:{as:'Container', className:'report-prepared-image-container'},
                        children:[
                          {
                            name: 'preparedForPhoto',
                            type: 'image',
                            displaySettings:{ className: 'report-prepared-image'},
                            label: 'Prepared For:',
                          },
                        ]
                      },
                      {
                        name: 'preparedFor',
                        type: 'text',
                        placeholder: 'Prepared For (Client)',
                      },
                      {
                        name: 'preparedForAddress',
                        type: 'text',
                        displaySettings:{as:'textarea'},
                        placeholder: 'Prepared For Address',
                      },
                    ]
                  },
                  {
                    name:'preparedByCol',
                    type:'Container',
                    displaySettings:{as: 'Col', sm:4, className:'report-prepared-by-col'},
                    children: [
                      {
                        name:'preparedByPhotoContainer',
                        type:'Container',
                        displaySettings:{as:'Container', className:'report-prepared-image-container'},
                        children:[
                          {
                            name: 'preparedByPhoto',
                            type: 'image',
                            displaySettings:{ className: 'report-prepared-image'},
                            label: 'Prepared By:'
                          },
                        ]
                      },
                      {
                        name: 'preparedBy',
                        type: 'text',
                        placeholder: 'Prepared By',
                      },
                      {
                        name: 'preparedByAddress',
                        type: 'text',
                        displaySettings:{as:'textarea'},
                        placeholder: 'Prepared By Address',
                      },
                    ]
                  }
                ]
              }
            ]
          },
          {
            name: 'projectSummaryContainer',
            type:'Container',
            displaySettings: { as: 'Container' },
            children:[
              {
                name: 'projectManagerStatement',
                type: 'markdown',
                label: 'Project Manager\'s Statement',
                displaySettings: {labelProps: { className: 'report-summary-label'}/*, enableChat: true*/}
              },
              {
                name: 'signature',
                type: 'image',
                placeholder: 'Signature',
                displaySettings: {className: 'report-signature-image'}
              },
              {
                name: 'signatorsName',
                type: 'text',
                placeholder: 'Signator\'s Name',
              },
              {
                name: 'signatorsTitle',
                type: 'text',
                placeholder: 'Signator\'s Title',
              },
              { 
                name: 'preparedByAddress',
                type: 'text',
                placeholder:'preparedByAddress'
              }
            ]
          },
          {
            name:'executiveSummaryContainer',
            type: 'Container',
            displaySettings: { as: 'Container' },
            children:[
              {
                name: 'executiveSummary',
                type: 'markdown',
                displaySettings: {labelProps: { className: 'report-summary-label'}/*, enableChat: true*/},
                label: 'Executive Summary'
              }
            ]
          },
        ]
      }
    ]
  }      